import { render, staticRenderFns } from "./product-export-modal.vue?vue&type=template&id=c04c467c&scoped=true"
import script from "./product-export-modal.vue?vue&type=script&lang=js"
export * from "./product-export-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04c467c",
  null
  
)

export default component.exports